import { Component, Input } from '@angular/core';
import { IDataHeaderComponent } from '@pacifico/interfaces/components.interface';

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
	@Input() dataHeader!: IDataHeaderComponent;
	showLegal = false;

	onclick(): void {
		this.showLegal = !this.showLegal;
		if (this.showLegal) {
			document.getElementsByTagName('body')[0].classList.add('mostrar_detalle');
			document.getElementById('modalLegal')?.classList.add('showLegal');
		} else {
			document.getElementsByTagName('body')[0].classList.remove('mostrar_detalle');
			document.getElementById('modalLegal')?.classList.remove('showLegal');
		}
	}
}
